// extracted by mini-css-extract-plugin
module.exports = {"container":"MasterDetail_container__3WCIi","detail":"MasterDetail_detail__11vJL","master":"MasterDetail_master__1e2-K"};